import React from 'react';
import { CardActions, RefreshButton } from 'react-admin';
import ExportAction from './ExportAction';

const UserActions = ({
  bulkActions,
  basePath,
  currentSort,
  displayedFilters,
  filters,
  filterValues,
  onUnselectItems,
  resource,
  selectedIds,
  showFilter,
}) => (
  <CardActions>
    {bulkActions &&
      React.cloneElement(bulkActions, {
        basePath,
        filterValues,
        resource,
        selectedIds,
        onUnselectItems,
      })}
    {filters &&
      React.cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: 'button',
      })}
    <ExportAction resource={resource} sort={currentSort} filter={filterValues} />
    <RefreshButton />
  </CardActions>
);

export default UserActions;



// WEBPACK FOOTER //
// ./src/resources/users/UserActions.jsx